export const GET_SECTORS = 'GET_SECTORS';
export const CRUD_SECTORS = 'CRUD_SECTORS';
export const CHANGE_SETTING = 'CHANGE_SETTING';
export const CLEAN_SECTORS_STATE = 'CLEAN_SECTORS_STATE';
export const CLEAN_SECTORS_ERROR = 'CLEAN_SECTORS_ERROR';
export const CHANGE_SETTING_LOCAL = 'CHANGE_SETTING_LOCAL';
export const SET_SECTORS_DATA = 'SET_SECTORS_DATA';
export const SET_FETECHING = 'SET_FETECHING';